import React, { useEffect, useState } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, RootStateOrAny } from 'react-redux';
import { updateShowWebPilotPosting, updateFaxOptOutProviders, updateVendorNames, updateCompanyNames } from 'store/app/actions';
import { Link, Redirect } from 'react-router-dom';
import moment from 'moment';

import { ALL_TEXT } from 'utils/objects';

import { logout } from 'store/auth/actions';

import { Badge, Button, Layout, Menu, Modal } from 'antd';
import {
  EditOutlined,
  SearchOutlined,
  FolderOutlined,
  LogoutOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  SwitcherOutlined,
  TeamOutlined,
  UserAddOutlined,
  UserOutlined,
  LinkOutlined,
  FileOutlined,
  InboxOutlined,
  MedicineBoxOutlined,
  OrderedListOutlined,
  CloudUploadOutlined,
  UploadOutlined,
  BankOutlined,
  FolderAddOutlined,
  ContainerOutlined,
  DatabaseOutlined,
  CommentOutlined,
  MailOutlined,
  WarningOutlined,
  CheckSquareOutlined,
  BarsOutlined,
  PieChartOutlined,
  SettingOutlined,
  FormOutlined,
  SolutionOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons';
import Title from "antd/lib/typography/Title";

import { BannerDetail, ErrorResponse } from 'utils/types';
import notifier from 'utils/notifier';
import { companyIdOptions, ORGANIZATION_NAME, USER_GUIDE_PATH } from 'utils/objects';
import { Company, UserRole } from 'utils/enums';
import { useDateTime, useRunOnce } from 'utils/hooks';
import constants from 'constants/index';

import { getNewItemsCount } from 'store/eligibility/carePlan/actions';
import { getGroupsAndCategories } from 'store/eligibility/documents/actions';
import { closeAnnouncementBar, closeUrgentAnnouncementBar } from 'store/app/announcements/actions';
import {
  getFaxOptOutExists,
  bulkInsertFaxOptOutProviders,
  FaxOptStatus,
  CompanyName
} from "store/app/actions";
import { getHelpCenterLinks } from 'store/app/helpCenter/actions';
import { getActiveBannerDetails } from 'store/app/banner/actions';

import SurveyModal from 'components/Common/SurveyModal';
import Banner from 'components/Common/Banner';

import GeneralLayoutProps from './Proptypes';
import './GeneralLayout.scss';


import astranaLogoWhite  from 'assets/images/Astrana_Symbol_White.svg';
import astranaLogoPlum  from 'assets/images/Astrana_Logo_Plum.svg';
import { addCustomAppInsightsEvent, isEmailAddressValid, isUserEnabledForPBI } from 'utils/helpers';

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

const GeneralLayout = (props: GeneralLayoutProps) => {
  const IS_SIX_MONTH_DIFF = moment().diff(moment(sessionStorage.getItem('modified_date')), 'months', true) > 6 ? true : false;
  const EMAIL = isEmailAddressValid(sessionStorage.getItem('email'));

  const initialState = {
    agree: false,
    approval: false,
    modified: false,
    denied: false,
    deferred: false,
    cancellation: false,
    dismissal: false,
    priorNotRequired: false,
    otherHealthCare: false,
    notAgree: false,
    selectAll: false
  };

  const [collapsed, setCollapsed] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [carePlanCount, setCarePlanCount] = useState(0);
  const [newDocCount, setNewDocCount] = useState(0);
  const [surveyModalVisible, setSurveyModalVisible] = useState(false);
  const [bannerDetails, setBannerDetails] = useState<BannerDetail[]>([]);
  const [helpCenter, setHelpCenter] = useState<any>([]);
  // Web pilot posting related
  const [letterState, setLetterState] = useState(initialState);
  const [menuState, setMenuState] = useState([props.location.pathname]);
  const date = useDateTime('second');
  const authEnabled = sessionStorage.getItem('auth_enabled');
  const claimEnabled = sessionStorage.getItem('claim_enabled');

  const openKeys = [];
  const separatedKeys = props.location.pathname.split('/');
  if (separatedKeys.length > 2) {
    openKeys.push(separatedKeys[1]);
  }

  useEffect(() => {
    getHelpCenterLinks();
  }, []);

  useEffect(() => {
    const companyInfo = companyIdOptions.find(
      (val: { companyId: string | null }) =>
        val.companyId === localStorage.getItem("print_ipa")
    );
    if (companyInfo && companyInfo.name) setCompanyName(companyInfo!.name);
    getDocumentGroupsAndCategories();
    getCarePlanCount();
    getActiveBannerDetails();
  }, [localStorage.getItem("print_ipa")]);

  // Run get fax opt once per session
  useRunOnce({
    fn: () => {
      getFaxOptOutExists();
    },
    sessionKey: "getFaxOptOutExistsCalled"
  });

  const getHelpCenterLinks = () => {
    props.getHelpCenterLinks(sessionStorage.getItem('ipaGroup')!, '', 'sidebar')
      .then((links: any) => {
        const helpCenterLink = links.find((link: any) => link.LinkName === 'Help Center');
        setHelpCenter(helpCenterLink);
      })
      .catch((err: ErrorResponse) => {
        console.log(err?.response?.data?.Message);
      });
  }

  const getFaxOptOutExists = async () => {
    const userId = sessionStorage.getItem('user_id');

    if (!userId) {
      notifier.error('getFaxOptOutExists: User ID not found in session storage. ');
      return;
    }

    try {
      const response: FaxOptStatus = await props.getFaxOptOutExists(userId);

      if (response.FaxOptOutProviders && response.FaxOptOutProviders.length > 0) {
        props.updateShowWebPilotPosting(true);
        props.updateFaxOptOutProviders(response.FaxOptOutProviders);
        props.updateVendorNames(response.VendorNames);
        props.updateCompanyNames(response.CompanyNames);
      }

    } catch (err: any) {
      // On error, disable the popup and notify the user
      props.updateShowWebPilotPosting(false);
      console.error(err?.response?.data?.Message || 'Something went wrong with getFaxOptOutExists, please contact a system administrator.');
    }
  };

  const checkLetterState = () => {
    if (letterState?.agree &&
      (letterState?.approval ||
      letterState?.modified ||
      letterState?.denied ||
      letterState?.deferred ||
      letterState?.cancellation ||
      letterState?.dismissal ||
      letterState?.priorNotRequired ||
      letterState?.otherHealthCare)) {
      return false;
    }

    if (letterState?.notAgree) {
      return false;
    }

    return true;
  }

  const handleAgreeChange = (checked: boolean) => {
    setLetterState((prevState: any) => ({
      ...prevState,
      agree: checked,
      notAgree: checked ? false : prevState.notAgree,
      approval: checked ? prevState.approval : false,
      modified: checked ? prevState.modified: false,
      denied: checked ? prevState.denied: false,
      deferred: checked ? prevState.deferred: false,
      cancellation: checked ? prevState.cancellation: false,
      dismissal: checked ? prevState.dismissal: false,
      priorNotRequired: checked ? prevState.priorNotRequired: false,
      otherHealthCare: checked ? prevState.otherHealthCare: false,
      selectAll: checked ? prevState.selectAll : false,
    }));
  };

  const handleNotAgreeChange = (checked: boolean) => {
    setLetterState((prevState: any) => ({
      ...prevState,
      notAgree: checked,
      agree: checked ? false : prevState.agree,
      approval: checked ? false : prevState.approval,
      modified: checked ? false : prevState.modified,
      denied: checked ? false : prevState.denied,
      deferred: checked ? false : prevState.deferred,
      cancellation: checked ? false : prevState.cancellation,
      dismissal: checked ? false : prevState.dismissal,
      priorNotRequired: checked ? false : prevState.priorNotRequired,
      otherHealthCare: checked ? false : prevState.otherHealthCare,
      selectAll: checked ? false : prevState.selectAll,
    }));
  };

  const handleSelectAllChange = (checked: boolean) => {
    setLetterState((prevState: any) => ({
      ...prevState,
      approval: checked,
      modified: checked,
      denied: checked,
      deferred: checked,
      cancellation: checked,
      dismissal: checked,
      priorNotRequired: checked,
      otherHealthCare: checked,
      selectAll: checked
    }));
  };

  const getAggregatedCompanyName = (companies: CompanyName[]): string => {
    const idsToCheck = ["APC", "AVISTA", "GSGP", "GOM", "ADV"];

    // Check if all companies have the companyId "APC"
    if (companies.every(company => company.companyId === "APC")) {
      return companies[0]?.companyName; // assuming all companyNames are same, taking the first one
    }

    // Check if any company has a combination of specified IDs
    if (companies.some(company => {
      const companyIdArray = company.companyId.split("/");
      return companyIdArray.some(id => idsToCheck.includes(id));
    })) {
      return 'Allied Pacific of California and Sub IPAs';
    }

    // If neither of the above conditions is met, return the companyName of the first company
    return companies[0]?.companyName;
  };

  const getAggregatedVendorName = (vendorNames: string[]): string => {
    return sessionStorage.getItem('user_id') || vendorNames.slice(0, 2).join(', ');
  };

  const submitWebPosting = () => {
    const letterTypeMapping = {
      approval: 'Approval',
      denied: 'Denial',
      modified: 'Modification',
      deferred: 'Deferral',
      cancellation: 'Cancellation',
      dismissal: 'Dismissal',
      priorNotRequired: 'PNR',
      otherHealthCare: 'OHCC'
    };

    let optInLetterTypes: string[] = [];
    let optOutLetterTypes: string[] = [];

    for (let [propName, letterType] of Object.entries(letterTypeMapping)) {
      if ((letterState as any)[propName]) {
          optInLetterTypes.push(letterType);
      } else {
          optOutLetterTypes.push(letterType);
      }
    }

    const userId = sessionStorage.getItem('user_id')!;
    const year = new Date().getFullYear();
    let payload: any[] = [];

    for (let provider of props.faxOptOutProviders) {
        const commonData = {
            userID: userId,
            companyId: provider.companyId,
            provKeyId: provider.provKeyId,
            year: year
        };

        payload.push({
            ...commonData,
            optIn: true,
            letterTypes: optInLetterTypes,
        });

        payload.push({
            ...commonData,
            optIn: false,
            letterTypes: optOutLetterTypes,
        });
    }

    props.bulkInsertFaxOptOutProviders(payload)
      .then(() => {
          notifier.success("You have successfully completed the web based attestation.");
      })
      .catch((err: ErrorResponse) => {
          notifier.error("An error occurred to enroll in web based communications.");
      });

    // Disable the popup right after the submit button clicked
    props.updateShowWebPilotPosting(false);
  }

  const getDocumentGroupsAndCategories = () => {
    if (sessionStorage.getItem('newDocCount')) setNewDocCount(parseInt(sessionStorage.getItem('newDocCount')!));
    else return props.getGroupsAndCategories(sessionStorage.getItem('user_id')!)
      .then((response: any[]) => {
        const total: number = response.reduce((accum, item) => accum + item.RmiNewDocCount, 0);
        setNewDocCount(total);
        sessionStorage.setItem('newDocCount', total.toString());
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const getCarePlanCount = () => {
    if (sessionStorage.getItem('carePlanCount')) setCarePlanCount(parseInt(sessionStorage.getItem('carePlanCount')!));
    else return props.getNewItemsCount(sessionStorage.getItem('user_id')!)
      .then((response: number) => {
        setCarePlanCount(response);
        sessionStorage.setItem('carePlanCount', response.toString());
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const getActiveBannerDetails = () => {
    return props.getActiveBannerDetails(sessionStorage.getItem('ipaGroup')!)
    .then((response: BannerDetail[]) => {
      setBannerDetails(response);
    })
    .catch((err: ErrorResponse) => {
      console.error(`errorMessage=${err?.response?.data}, errorType=${err?.response?.status}:${err?.response?.statusText}`);
    });
  };

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const gotoUrl = (url: string) => {
    if (IS_SIX_MONTH_DIFF || !EMAIL) {
      return <Redirect to="/account/profile" />;
    } else {
      const payload = {
        ipa: sessionStorage.getItem("ipaGroup"),
        url
      }
      addCustomAppInsightsEvent(url, payload);
      props.history.push(url);
    }
  };

  // handles the sidebar menu click to keep track which one is active
  const handleClick = (e: any) => {
    if (IS_SIX_MONTH_DIFF || !EMAIL) {
      setMenuState(['/account/profile']);
      return;
    }
    setMenuState(e.keyPath)
  }

  const isUserEnabledForAWV = (userId: any, enabledUsers: any) => {
    const enabledUserIds = enabledUsers.split(',').map((user: any) => user.trim())
    return (enabledUserIds.includes(userId) || enabledUserIds.includes(ALL_TEXT)) &&
           (constants.AWV_ENABLE_IPA.includes(ALL_TEXT) || constants.AWV_ENABLE_IPA.includes(sessionStorage.getItem("ipa")));
  };

  const helpCenterLink = () => {
    const model = {
      "ClickEventId": helpCenter[0]?.clickEventId,
      "LinkName": helpCenter[0]?.linkName,
      "PagePath": helpCenter[0]?.pagePath,
      "Url": helpCenter[0]?.url,
      "CompanyId": helpCenter[0]?.companyId,
      "User": sessionStorage.user_id
    }

    addCustomAppInsightsEvent(helpCenter[0]?.clickEventId, model);
    window.open(helpCenter?.length > 0 ? helpCenter[0]?.Link : 'https://astranahealth.notion.site/Provider-Portal-Help-Center-07d30b03ee2d431ca6b605c10b68deb6', '_blank')
  }

  return (
    <>
      {(props.announcementBarVisible && bannerDetails) &&
        <Banner
          bannerDetails={bannerDetails}
          pagePath={props.location.pathname}
        />
      }
      {sessionStorage.getItem('user_role')! !== UserRole.THIRD_PARTY &&

        <SurveyModal
          visible={surveyModalVisible}
          setVisible={setSurveyModalVisible}
        />

      }
      <Layout className="general-layout">

      {(sessionStorage.getItem('user_role') !== UserRole.THIRD_PARTY && !IS_SIX_MONTH_DIFF && EMAIL) &&
      <Sider trigger={null} collapsible collapsed={collapsed} width={'270px'}>
        <div className="logo" style={{ display: "flex", alignItems: "center" }}>
          <Link to="/quality/overview" style={{ textDecoration: 'none', color: 'white', display: 'flex', alignItems: 'center' }}>
            <img src={astranaLogoWhite} style={{ width: '25px' }} alt="logo" />
            {!collapsed && <span style={{ fontSize: '22px', marginLeft: '10px', marginTop: '3px' }}>Provider Portal</span>}
          </Link>
        </div>
        <Menu theme="dark" mode="inline" onClick={(e: any) => handleClick(e)} selectedKeys={menuState} defaultSelectedKeys={[props.location.pathname]} defaultOpenKeys={openKeys}>

          <Menu.Item key="/quality/overview" onClick={() => gotoUrl('/quality/overview')} icon={<PieChartOutlined /> } title="Quality Overview">
            Quality Overview
          </Menu.Item>

          { isUserEnabledForPBI(sessionStorage.getItem('user_id'), constants.PBI_ENABLE_USER) ? (
          <Menu.Item key="/powerbi" onClick={() => gotoUrl('/powerbi')} icon={<PieChartOutlined /> } title="Provider Compensation Dashboard">
            Compensation Dashboard
          </Menu.Item>
          ) : null}

          <Menu.Item key="/annual-wellness-visit" onClick={() => gotoUrl("/annual-wellness-visit")} icon={<SolutionOutlined /> } title="Annual Visit">
            Annual Visit
          </Menu.Item>


          <SubMenu key="eligibility" icon={<TeamOutlined /> } title="Eligibility">
            <Menu.Item key="/eligibility/search" icon={<SearchOutlined />}
                        onClick={() => gotoUrl('/eligibility/search')}>
              Search Eligibility
            </Menu.Item>
            <Menu.Item key="/eligibility/member-request" icon={<MedicineBoxOutlined />}
                        onClick={() => gotoUrl('/eligibility/member-request')}>
              Member Request
            </Menu.Item>
          </SubMenu>

          <SubMenu
            key="auth"
            icon={<BankOutlined />}
            title="Authorization"
            disabled={authEnabled === 'N'}
          >
            <Menu.Item key="/auth/create" icon={<FolderAddOutlined />} onClick={() => gotoUrl('/auth/create')}>
              Create Authorization
            </Menu.Item>
            <Menu.Item key="/auth/search" icon={<SearchOutlined />}
                        onClick={() => gotoUrl('/auth/search')}>
              Search Authorization
            </Menu.Item>
            <Menu.Item key="/auth/letter-search" icon={<ContainerOutlined />}
                        onClick={() => gotoUrl('/auth/letter-search')}>
              Search Authorization Letters
            </Menu.Item>
            <Menu.Item
              key="/auth/open-auth"  icon={<ContainerOutlined />}
              onClick={() => gotoUrl('/auth/open-auth')}
            >
              Open Authorizations
            </Menu.Item>
          </SubMenu>


          <SubMenu
            key="claims"
            icon={<SwitcherOutlined />}
            title="Claims"
            disabled={claimEnabled === 'N'}
          >
            <Menu.Item key="/claims/create" icon={<CloudUploadOutlined />}
                        onClick={() => gotoUrl('/claims/create')}>
              Create Claim
            </Menu.Item>
            <Menu.Item key="/claims/submitted-claims" icon={<ContainerOutlined />}
                        onClick={() => gotoUrl('/claims/submitted-claims')}>
              Submitted Portal Claims
            </Menu.Item>
            <Menu.Item key="/claims/batch/create" icon={<UploadOutlined />}
                        onClick={() => gotoUrl('/claims/batch/create')}>
              Create Batch Claim
            </Menu.Item>
            <Menu.Item key="/claims/batch/submitted" icon={<ContainerOutlined />}
                        onClick={() => gotoUrl('/claims/batch/submitted')}>
              Submitted Batch Claims
            </Menu.Item>
            <Menu.Item key="/claims/search" icon={<SearchOutlined />}
                        onClick={() => gotoUrl('/claims/search')}>
              Search Claims
            </Menu.Item>
          </SubMenu>

          <SubMenu key="case-mgmt" icon={<InboxOutlined /> } title={
            sessionStorage.getItem('user_role')! !== UserRole.HEALTH_PLAN ?
            <>
              Case Management
              <Badge count={carePlanCount} overflowCount={99999} offset={[30, 7]}>
                &nbsp;
              </Badge>
            </>
              :
              <>Case Management</>
          }>
            <Menu.Item key="/case-mgmt/care-plans" icon={< MedicineBoxOutlined />}
                        onClick={() => gotoUrl('/case-mgmt/care-plans')} disabled={sessionStorage.getItem('user_role')! === UserRole.HEALTH_PLAN}>
            {sessionStorage.getItem('user_role')! !== UserRole.HEALTH_PLAN ?
            <>
              Care Plans
              <Badge count={carePlanCount} overflowCount={99999} offset={[30, 7]}>
                &nbsp;
              </Badge>
            </>
              :
              <>Care Plans</>
            }
            </Menu.Item>
            <Menu.Item key="/case-mgmt/task-list" icon={<OrderedListOutlined />}
              onClick={() => gotoUrl('/case-mgmt/task-list')}
              disabled={ sessionStorage.getItem('user_role') !== UserRole.CASE && sessionStorage.getItem('user_role') !== UserRole.HEALTH_PLAN }>
              Task List
            </Menu.Item>
          </SubMenu>

          <SubMenu key="documents" icon={<DatabaseOutlined />} title="New Documents">
            <Menu.Item key="/documents/new-documents" icon={<FileOutlined />} onClick={() => gotoUrl('/documents/new-documents')}  disabled={sessionStorage.getItem('user_role')! === UserRole.HEALTH_PLAN}>
              {sessionStorage.getItem('user_role')! !== UserRole.HEALTH_PLAN ?
              <>
                New Documents
                <Badge count={newDocCount} overflowCount={99999} offset={[30, 7]} style={{ backgroundColor: 'orange' }}>
                  &nbsp;
                </Badge>
              </>
                :
                <>New Documents</>
              }
            </Menu.Item>

            <Menu.Item
              key="/documents/memos"
              onClick={() => gotoUrl('/documents/memos') }
            >
              Memos
            </Menu.Item>
              <Menu.Item
                key="/documents/consult-notes"
                onClick={() => gotoUrl('/documents/consult-notes')}
              >
              Consult Notes
            </Menu.Item>
            <Menu.Item
              key="/documents/case-documents"
              onClick={() => gotoUrl('/documents/case-documents')}
            >
              Case Documents
            </Menu.Item>
            <Menu.Item
              key="/documents/ccs-aging"
              onClick={() => gotoUrl('/documents/ccs-aging')}
            >
              CCS Aging Out Documents
            </Menu.Item>
            <Menu.Item
              key="/documents/rescind-notice"
              onClick={() => gotoUrl('/documents/rescind-notice')}
            >
              Rescind Notice
            </Menu.Item>
            {/* ---- Hiding the Member Roster Card from New Documents Panel (Story 49964) --
            <Menu.Item
              key="/documents/member-roster"
              onClick={() => gotoUrl('/documents/member-roster')}
            >
              Member Roster
            </Menu.Item> */}
            <Menu.Item
              key="/documents/misc"
              onClick={() => gotoUrl('/documents/misc')}
            >
              Miscellaneous
            </Menu.Item>
          </SubMenu>

          <SubMenu key="hcc" icon={<CheckSquareOutlined /> } title="HCC">
            <Menu.Item key="/hcc/risk-score" icon={<BarsOutlined />}
                        onClick={() => gotoUrl('/hcc/risk-score')}>
              HCC Risk Score
            </Menu.Item>
            <Menu.Item key="/hcc/gap-members" icon={<UserOutlined />}
                        onClick={() => gotoUrl('/hcc/gap-members')}>
              HCC Gap Members
            </Menu.Item>
          </SubMenu>

          <SubMenu key="resources" icon={<DatabaseOutlined />} title="Resources">
            <Menu.Item key="/resources/forms" icon={<EditOutlined />}
                        onClick={() => gotoUrl('/resources/forms')}>
              Forms
            </Menu.Item>
            <Menu.Item key="/resources/nmmupdates" icon={<FolderOutlined />}
                        onClick={() => gotoUrl('/resources/nmmupdates')}>
              Astrana Updates
            </Menu.Item>
            <Menu.Item key="/resources/provider" icon={<FolderOutlined />}
                        onClick={() => gotoUrl('/resources/provider')}>
              Provider Resources
            </Menu.Item>
            <Menu.Item key="/resources/edu" icon={<FolderOutlined />}
                        onClick={() => gotoUrl('/resources/edu')}>
              Patient Resources
            </Menu.Item>
          </SubMenu>

          <SubMenu key="contact" icon={<CommentOutlined />} title="Contact Us">
            <Menu.Item key="/contact/us" icon={<MailOutlined />}
                        onClick={() => gotoUrl('/contact/us')}>
              Contact Us
            </Menu.Item>
            <Menu.Item key="/contact/report" icon={<WarningOutlined />}
                        onClick={() => gotoUrl('/contact/report')}>
              Report Issues
            </Menu.Item>
          </SubMenu>

          <Menu.Item key="/vendor-portal" icon={<LinkOutlined />} onClick={() =>
            window.open('https://vendor-portal.astranahealth.com/', '_blank')
          }>
            Vendor Portal
          </Menu.Item>

          <Menu.Item key="/pathways" icon={<LinkOutlined />} onClick={() =>
            window.open('https://providers.apaaco.net/', '_blank')
          }>
            ACO Portal
          </Menu.Item>

          <SubMenu key="account" icon={<SettingOutlined /> } title="Account Settings">
            <Menu.Item key="/account/profile" icon={<UserOutlined />} onClick={() => gotoUrl('/account/profile')}>
              Profile
            </Menu.Item>

            <Menu.Item key="/account/change-password" icon={<FormOutlined />} onClick={() => gotoUrl('/account/change-password')}>
              Change Password
            </Menu.Item>
          </SubMenu>

          <Menu.Item key="/help-center" icon={<QuestionCircleOutlined />} onClick={() => helpCenterLink()}>
            {helpCenter?.length > 0 ? helpCenter[0]?.LinkName : 'Help Center'}
          </Menu.Item>

          <Menu.Item key="/logout" icon={<LogoutOutlined />} onClick={() => props.logout()}>
            Logout
          </Menu.Item>
        </Menu>
      </Sider>

      }
      <Layout className="site-layout">
        <Header className="site-layout-background" style={{ padding: 0 }}>
          {(sessionStorage.getItem('user_role') === UserRole.THIRD_PARTY || IS_SIX_MONTH_DIFF || !EMAIL) &&
            <div className="logout-link">
              <a onClick={() => props.logout()} className="logout-link">
                Logout
              </a>
            </div>
          }

          {(sessionStorage.getItem('user_role') !== UserRole.THIRD_PARTY && !IS_SIX_MONTH_DIFF&& EMAIL) &&
            React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
              className: 'trigger',
              onClick: toggleCollapse,
            })
          }

          {/* Commenting this out for now. Some print pages have and some don't. It's not consistent.
            <img src={logoPng} className="print-logo" alt="logo" style={{width: '125px', height: '88px'}} />
          */}

          <div className="company-name"> {companyName}</div>
        </Header>

        <Content className="site-layout-content">
          <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
            {props.children}
          </div>
        </Content>

        <Footer className="site-layout-footer">
          <div className="row">
            <div className="col-lg-8 d-flex justify-content-start">
            Portal Support: {props.portalContact}
            </div>
            <div className="col-lg-8">
            Version: {props.version}
            <br />
            Build: {constants.BUILD_NUMBER}
            </div>
            <div className="col-lg-8 d-flex justify-content-end" style={{ textAlign: 'right' }}>
            {moment(date).format('MMM DD, YYYY hh:mm:ss A')}
            <br/>
            Copyright {ORGANIZATION_NAME}, Inc. © {moment().year()}
            </div>
          </div>
        </Footer>

      </Layout>
    </Layout>

    <Modal
      visible={props.showWebPilotPosting}
      maskClosable={false}
      closable={false}
      keyboard={false}
      width={1000}
      centered
      footer={[
        <div
          className="mb-3"
          style={{ textAlign: "center", padding: "10px" }}
        >
          <p style={{ margin: "10px 0" }}>
            <strong>Disclaimer:</strong> You are required to attest to this
            notification within fourteen (14) business days of receipt.
            Failure to respond to this notification will result in automatic
            enrollment in the Web Portal Posting Program for twelve (12)
            calendar months.
          </p>
          <Button
            type="primary"
            style={{ margin: "10px 0" }}
            onClick={submitWebPosting}
            disabled={checkLetterState()}
            loading={props.isCreatingWebPilotPosing}
          >
            Submit
          </Button>
          <p style={{ marginTop: "20px" }}>
            &copy; {ORGANIZATION_NAME}, Inc., All Rights Reserved
          </p>
        </div>
      ]}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginBottom: "20px",
          position: "relative", // Add position relative to the container
        }}
      >
        <img
          src={astranaLogoPlum}
          width={"250px"}
          style={{ position: "absolute", top: 0 }} // Position the image at the top
        />
        <Title level={2} style={{ marginTop: "40px" }}>Fax Opt-Out for Provider Notification Letters</Title>
      </div>

      <p style={{ margin: "20px 0" }}>
        Dear {getAggregatedVendorName(props.vendorNames)},
        <br />
        <br />
        {getAggregatedCompanyName(props.companyNames)} is excited to offer you
        the option to receive all communications regarding authorization
        determinations (approvals, modifications, and denials) directly
        through the {ORGANIZATION_NAME} provider portal, rather than via fax. You will
        no longer have to wait for a faxed letter.
        <br />
        <br />
        To participate in this program, you and/or your office staff must
        agree to check the {ORGANIZATION_NAME} provider portal at least every 4 hours
        during the workday to ensure timely delivery of care, pursuant to
        health plan and regulatory requirements.
      </p>

      <div style={{ margin: "20px 0" }}>
        <input
          type="checkbox"
          checked={letterState.agree}
          onChange={(e) => handleAgreeChange(e.target.checked)}
          id="agree"
        />
        <label htmlFor="agree" style={{ marginLeft: "10px" }}>
          Yes, I agree to participate in the Web Portal Posting Program
        </label>
        <br />
        {letterState.agree && (
          <>
            <ul style={{ padding: '0px 0px 0px 24px', marginBottom: '0px'}}>
              <li style={{ listStyleType: "none", padding: 0 }}>
                <input
                  type="checkbox"
                  checked={letterState.selectAll}
                  onChange={(e) => handleSelectAllChange(e.target.checked)}
                  id="selectAll"
                />
                <label htmlFor="selectAll" style={{ marginLeft: "10px" }}>
                  Select All
                </label>
              </li>
            </ul>
            <ul style={{ marginLeft: '8px'}}>
              <li style={{ listStyleType: "none", padding: 0 }}>
                <input
                  type="checkbox"
                  checked={letterState.approval}
                  onChange={(e) =>
                    setLetterState((prevState: any) => ({
                      ...prevState,
                      approval: e.target.checked,
                      selectAll: false
                    }))
                  }
                  id="approval"
                />
                <label htmlFor="approval" style={{ marginLeft: "10px" }}>
                  Approval
                </label>
              </li>
              <li style={{ listStyleType: "none", padding: 0 }}>
                <input
                  type="checkbox"
                  checked={letterState.modified}
                  onChange={(e) =>
                    setLetterState((prevState: any) => ({
                      ...prevState,
                      modified: e.target.checked,
                      selectAll: false
                    }))
                  }
                  id="modified"
                />
                <label htmlFor="modified" style={{ marginLeft: "10px" }}>
                  Modified
                </label>
              </li>
              <li style={{ listStyleType: "none", padding: 0 }}>
              <input
                  type="checkbox"
                  checked={letterState.denied}
                  onChange={(e) =>
                    setLetterState((prevState: any) => ({
                      ...prevState,
                      denied: e.target.checked,
                      selectAll: false
                    }))
                  }
                  id="denied"
                />
                <label htmlFor="denied" style={{ marginLeft: "10px" }}>
                  Denied
                </label>
              </li>
              <li style={{ listStyleType: "none", padding: 0 }}>
                <input
                  type="checkbox"
                  checked={letterState.deferred}
                  onChange={(e) =>
                    setLetterState((prevState: any) => ({
                      ...prevState,
                      deferred: e.target.checked,
                      selectAll: false
                    }))
                  }
                  id="deferred"
                />
                <label htmlFor="deferred" style={{ marginLeft: "10px" }}>
                  Deferred
                </label>
              </li>
              <li style={{ listStyleType: "none", padding: 0 }}>
                <input
                  type="checkbox"
                  checked={letterState.cancellation}
                  onChange={(e) =>
                    setLetterState((prevState: any) => ({
                      ...prevState,
                      cancellation: e.target.checked,
                      selectAll: false
                    }))
                  }
                  id="cancellation"
                />
                <label htmlFor="cancellation" style={{ marginLeft: "10px" }}>
                  Cancellation
                </label>
              </li>
              <li style={{ listStyleType: "none", padding: 0 }}>
                <input
                  type="checkbox"
                  checked={letterState.dismissal}
                  onChange={(e) =>
                    setLetterState((prevState: any) => ({
                      ...prevState,
                      dismissal: e.target.checked,
                      selectAll: false
                    }))
                  }
                  id="dismissal"
                />
                <label htmlFor="dismissal" style={{ marginLeft: "10px" }}>
                  Dismissal
                </label>
              </li>
              <li style={{ listStyleType: "none", padding: 0 }}>
                <input
                  type="checkbox"
                  checked={letterState.priorNotRequired}
                  onChange={(e) =>
                    setLetterState((prevState: any) => ({
                      ...prevState,
                      priorNotRequired: e.target.checked,
                      selectAll: false
                    }))
                  }
                  id="priorNotRequired"
                />
                <label
                  htmlFor="priorNotRequired"
                  style={{ marginLeft: "10px" }}
                >
                  Prior Not Required
                </label>
              </li>
              <li style={{ listStyleType: "none", padding: 0 }}>
                <input
                  type="checkbox"
                  checked={letterState.otherHealthCare}
                  onChange={(e) =>
                    setLetterState((prevState: any) => ({
                      ...prevState,
                      otherHealthCare: e.target.checked,
                      selectAll: false
                    }))
                  }
                  id="otherHealthCare"
                />
                <label htmlFor="otherHealthCare" style={{ marginLeft: "10px" }}>
                  Other Health Care Coverage
                </label>
              </li>
            </ul>
          </>
        )}
        <input
          type="checkbox"
          checked={letterState.notAgree}
          onChange={(e) => handleNotAgreeChange(e.target.checked)}
          id="notAgree"
        />
        <label htmlFor="notAgree" style={{ marginLeft: "10px" }}>
          No, I do NOT agree to participate in the Web Portal Posting Program
        </label>
      </div>
    </Modal>
    </>
  );
}

const mapStateToProps = (state: RootStateOrAny) => ({
  announcementBarVisible: state.persistedReducer.appAnnouncements.announcementBarVisible,
  urgentAnnouncementBarVisible: state.persistedReducer.appAnnouncements.urgentAnnouncementBarVisible,
  isAcoMember: state.rootReducer.aco.isAcoMember, // Determines if logged in user is part of ACO program
  isFetchingAwv: state.rootReducer.aco.isFetchingAwv,
  isCreatingWebPilotPosing: state.rootReducer.app.isCreatingWebPilotPosing,//submitting Fax Opt
  showWebPilotPosting: state.rootReducer.app.showWebPilotPosting, // showWebPilotPosting
  faxOptOutProviders: state.rootReducer.app.faxOptOutProviders, // Get list of faxOptOut providers
  companyNames: state.rootReducer.app.companyNames, // Get list of company names
  vendorNames: state.rootReducer.app.vendorNames, // Get list of vendor names
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    getGroupsAndCategories,
    getNewItemsCount,
    closeAnnouncementBar,
    closeUrgentAnnouncementBar,
    logout,
    getActiveBannerDetails,
    getFaxOptOutExists,
    bulkInsertFaxOptOutProviders,

    updateShowWebPilotPosting,
    updateFaxOptOutProviders,
    updateCompanyNames,
    updateVendorNames,
    getHelpCenterLinks,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(GeneralLayout);
